angular
  .module('contabilidad.polizasexternas')
  .service(
    'PolizasExternasProvisionComprasBoAg',
    PolizasExternasProvisionComprasBoAg,
  )

PolizasExternasProvisionComprasBoAg.$inject = ['$http']

function PolizasExternasProvisionComprasBoAg ($http) {
  this.get = get

  function get (busqueda) {
    return $http.get('/api/contabilidad/polizasexternas/provision_comprasboag', {
      params: {
        fecha_inicio: busqueda.fechaInicial.toYMD(),
        fecha_fin: busqueda.fechaFinal.toYMD(),
      },
      schema: {
        fecha: 'date',
        fechaDMY: 'date',
        lnf: 'bool',
        total: 'number',
        total_calculado: 'number',
        total_debe: 'number',
        total_haber: 'number',
        detalles: {
          ccbo: 'boolean',
          importe: 'number',
        },
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/services/PolizasExternasProvisionComprasBoAg.js